export default __webpack_public_path__ + "static/byron_filming-4ec0eeb53780dd4131c2ea78878480c3.jpg";